
	import { defineComponent, getCurrentInstance, ref, onMounted, reactive } from 'vue'
	import { useTableScroll } from '@/common/mixins/useTableScroll'
	import { UsePageDto } from '@/common/mixins/listPageDto'
	import { setAllSelect } from '@/common/mixins/setAllSelect'
	import ossUpload from '@/common/functions/ossUpload'
	import { PlusOutlined } from '@ant-design/icons-vue'
	import { getShopList, auditAndRelease, getTemplateList } from './request'
	import { message } from 'ant-design-vue'
	import { versionColumns as columns } from './config'
	export default defineComponent({
		components: {
			PlusOutlined
		},
		setup() {
			const instance = getCurrentInstance()
			const { scroll } = useTableScroll(instance)
			const { pagination, listPageDto, handleTableChange, refresh } = UsePageDto(instance)
			const tableData = ref([])
			const { selectedRowKeys, rowSelection } = setAllSelect(tableData, 'appId')
			const visible = ref(false)
			const loading = ref(false)
			const formModal = reactive({
				feedbackInfo: '',
				feedbackStuff: []
			})
			const fetchList = async () => {
				try {
					const { data } = await getShopList({
						pageDto: {
							pageNum: listPageDto.pageNum,
							pageSize: listPageDto.pageSize
						}
					})
					tableData.value = data
				} catch (e) {
					console.error(e)
				}
			}
			const templateList = ref([])
			const filter = reactive({
				templateId: null
			})
			const fetchTemplateList = async () => {
				try {
					const res = await getTemplateList()
					templateList.value = res.data.map((item) => ({
						value: item.templateId,
						label: `${item.version}`
					}))
					Object.assign(listPageDto, res.pageDto)
				} catch (e) {
					console.error(e)
				}
			}

			async function customUploadRequest(param) {
				let res: any = await ossUpload(param)
				let data = res.data || {}
				console.log(res)
				formModal.feedbackStuff.push(data.url as never)
			}
			const close = ()=> {
				visible.value = false
			}
			const postAudit = async () => {
				try {
					loading.value = true
					let res = await auditAndRelease({
						templateId: filter.templateId + '',
						appIds: selectedRowKeys.value,
						feedbackInfo: formModal.feedbackInfo,
						feedbackStuff: formModal.feedbackStuff
					})
					loading.value = false
					if (res.data) {
						message.warn(res.data + '提交失败')
					} else {
						message.success('保存成功')
					}
					visible.value = false
					selectedRowKeys.value = []
					fetchList()
				} catch (e) {
					loading.value = false
					console.error(e)
				}
			}

			onMounted(() => {
				fetchList()
				fetchTemplateList()
			})
			return {
				scroll,
				columns,
				tableData,
				pagination,
				handleTableChange,
				rowSelection,
				postAudit,
				templateList,
				filter,
				visible,
				formModal,
				close,
				loading,
				customUploadRequest
			}
		}
	})
